function parseAbsoluteUrl(raw) {
    const value = String(raw || '').trim();
    if (!value) return null;
    try {
        return new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : `https://${value}`);
    } catch {
        return null;
    }
}

/** Match redirectProject / ERP backend: t.me, telegram.me, telegram.org. */
export function isTelegramDestination(raw) {
    const parsed = parseAbsoluteUrl(raw);
    const host = String(parsed?.hostname || raw || '')
        .replace(/^www\./i, '')
        .toLowerCase();
    return (
        host === 't.me' ||
        host.endsWith('.t.me') ||
        host === 'telegram.me' ||
        host.endsWith('.telegram.me') ||
        host === 'telegram.org' ||
        host.endsWith('.telegram.org')
    );
}

export function remainPathAllowed(destinationUrl) {
    return !isTelegramDestination(destinationUrl);
}
